const firebaseConfig = {
    apiKey: "AIzaSyCKncOeB6HvvJiu66w2hDXg3v4Ow-MH-3c",
    authDomain: "tripntour-97f5d.firebaseapp.com",
    projectId: "tripntour-97f5d",
    storageBucket: "tripntour-97f5d.appspot.com",
    messagingSenderId: "87314357628",
    appId: "1:87314357628:web:d7d35ab9697f21146618f9",
    measurementId: "G-YGB80J0ZBK"
  };
export default firebaseConfig;